// Who a ticket message is from.
//
// Megan replied to a ticket by email on 7-28 and the thread showed it as Dusty, because
// the old rule was "not FIG support ⇒ the person who raised the ticket":
//
//   msgUserName: x.IsSentByFigSupport ? "FIG Support" : (t.UserName || t.Email)
//
// That held only while every message was typed into the site by one of two people. Once
// replies arrive by email it is wrong twice over: an inbound reply can come from anyone,
// and "FIG Support" never said which of the support staff had answered.
//
// SupportTicketTransaction carries SenderName and SenderEmail, written by the mailbox
// poller from the message's From header. The ticket creator remains the fallback, because
// that is genuinely who wrote every reply made through the site before those columns
// existed.

const truthy = (v) => v === true || v === 1;

/**
 * @param {object} tx      SupportTicketTransaction row
 * @param {object} ticket  its SupportTicketMst row
 * @returns {{name: string, email: string|null, isStaff: boolean}}
 */
export const messageAuthor = (tx, ticket = {}) => {
  const isStaff = truthy(tx?.IsSentByFigSupport);
  const senderName = String(tx?.SenderName || "").trim();
  const senderEmail = String(tx?.SenderEmail || "").trim();

  if (senderName || senderEmail) {
    return { name: senderName || senderEmail, email: senderEmail || null, isStaff };
  }

  if (isStaff) {
    return { name: "FIG Support", email: null, isStaff: true };
  }

  return {
    name: ticket.UserName || ticket.Email || "Unknown",
    email: ticket.Email || null,
    isStaff: false,
  };
};

export default messageAuthor;
